module.exports = __webpack_public_path__ + "media/images/icon_rank_03-a7514eec612fc295c2adc0c3983d7a67.png";